export const useIsMailAppAvailable = () => false
